export default __webpack_public_path__ + "static/media/85-min.bc50ea0c.jpg";